/*!
 * e3-modal JavaScript Library v0.0.25
 *
 * Released under the MIT license
 *
 * Date: 2020-07-01T16:29Z
 */

(function(global, factory) {

  if (typeof define === 'function' && define.amd) {
    define('e3-modal',
      ['jquery', 'underscore', 'vertebrae', 'bluebird', 'handlebars', 'bootstrap'], factory);
  } else {
    factory((global.jQuery || global.$), global._, {}, global.Promise, global.Handlebars);
  }

}(this, function($, _, Vertebrae, Promise, Handlebars) {

  var ModalView = Vertebrae.View.extend({

    templates: {
      'modal.init'          : 'renderModalFragment',
      'modal.header.base'   : 'renderHeaderFragment',
      'modal.footer.base'   : 'renderFooterFragment'
    },

    events: {
      'show.bs.modal'          : 'viewDidShow',
      'shown.bs.modal'         : 'viewDidFinishShowing',
      'hide.bs.modal'          : 'viewDidHide',
      'hidden.bs.modal'        : 'viewDidFinishHiding',

      'click [data-action]'    : 'handleModalBtnClick',
      'keydown [role="button"]': 'handleModalBtnKeydown'
    },

    render: function() {
      var delegate = this.getDelegate(),
          frag     = this.renderModalFragment(delegate),
          dialogEl = frag.children();

      this.renderHeaderToElement(dialogEl.find('.modal-header'), delegate);
      this.renderBodyToElement(dialogEl.find('.modal-body'));
      this.renderFooterToElement(dialogEl.find('.modal-footer'));

      this.$el.html(frag);
    },

    /**
     * Passes in the header element and inserts content into it
     *
     * @function
     * @instance
     *
     * @param  {Element} el       The header element
     *
     * @return {None}
     */
    renderHeaderToElement: function(el, options) {
      el.html(this.renderHeaderFragment(options));
    },

    /**
     * Passes in the body element and inserts content into it
     *
     * @function
     * @instance
     *
     * @param  {Element} el The body element
     *
     * @return {None}
     */
    renderBodyToElement: function(el) {
      el.html('');
    },

    /**
     * Render the footer element for the current section again
     *
     * @function
     * @instance
     *
     * @return {None}
     */
    renderFooterToElement: function(el) {
      var delegate = this.getDelegate();

      el.html(this.renderFooterFragment({
        footerText: delegate.getFooterText(),
        buttons:    this.generateFooterBtns()
      }));
    },

    generateFooterBtns: function() {
      var btnDefinitions = (this.getDelegate().getButtons() || []).slice(),
          len            = btnDefinitions.length,
          btnDefinition  = null,
          btn            = null,
          btns           = '';

      btnDefinitions.reverse();

      for (var i = 0; i < len; i++) {
        btnDefinition = btnDefinitions[i];
        btn = $('<div role="button" tabindex="0"/>');

        // Add Bootstrap Btn Classes
        btn.addClass('btn');
        btn.addClass('btn-' + (btnDefinition.color || 'default'));

        // Add Position
        btn.addClass('pull-' + (btnDefinition.position || 'right'));

        // Disabled
        if (btnDefinition.disabled) {
          btn.addClass('disabled');
          btn.attr('aria-disabled', true);
        }

        // aria-label
        btn.attr('aria-label', btnDefinition.ariaLabel || null);

        // aria-labelledby
        btn.attr('aria-labelledby', btnDefinition.ariaLabelledby || null);

        // aria-describedby
        btn.attr('aria-describedby', btnDefinition.ariaDescribedby || null);

        // Add Hover Title
        btn.attr('title', btnDefinition.title || null);

        // Add OnClick Actions
        btn.attr('data-action', btnDefinition.action || null);

        // Add OnClick Links
        btn.attr('data-link', btnDefinition.link || null);

        // Add Dismiss Action
        if (btnDefinition.dismiss) {
          btn.attr('data-dismiss', 'modal');
        }

        // Add Indicated Icon
        if (btnDefinition.icon) {
          var icon = btn.html('<i></i>').find('i');

          icon.addClass('fa-icon');
          icon.addClass('fa-icon-' + btnDefinition.icon);

          if (btnDefinition.text) {
            // we do not want to make the icon pull right
            // anymore...
            // icon.addClass('pull-right');
          } else {
            btn.addClass('text-center');
          }
        }

        // Append Text
        if (btnDefinition.text) {
          btn.append(btnDefinition.text);
        }

        btns += btn.get(0).outerHTML;
      }

      return btns;
    },

    refreshFooter: function() {
      this.renderFooterToElement(this.getFooterElement());
    },

    getDialogElement: function() {
      return this.$('.modal-dialog');
    },

    /**
     * Returns the modal header element
     *
     * @function
     * @instance
     *
     * @return {Element}
     */
    getHeaderElement: function() {
      return this.$('.modal-header');
    },

    /**
     * Returns the modal body element
     *
     * @function
     * @instance
     *
     * @return {Element}
     */
    getBodyElement: function() {
      return this.$('.modal-body');
    },

    /**
     * Returns the footer element
     *
     * @function
     * @instance
     *
     * @return {Element}
     */
    getFooterElement: function() {
      return this.$('.modal-footer');
    },

    getTitle: function() {
      return this.$('.modal-title').text();
    },

    /**
     * Get the element for a specific section view
     *
     * @function
     * @instance
     *
     * @param  {Evisions.Modal.ModalSectionController} Section controller
     *
     * @return {Element}
     */
    getModalSectionElement: function(section) {
      var view        = section.getView(),
          modalBodyEl = this.getBodyElement(),
          sectionEl   = modalBodyEl.find('#' + view.cid);

      if (!sectionEl.length) {
        // Create initially hidden section
        sectionEl = $('<div/>').hide().addClass('modal-section').attr('id', view.cid);

        // Section ClassName
        if (view.className) {
          sectionEl.addClass(view.className);
        }
        // Section Defined Modal ClassName
        if (view.modalClassName) {
          this.getDialogElement().addClass(view.modalClassName);
        }

        modalBodyEl.append(sectionEl);
      }

      return sectionEl;
    },

    /**
     * If there is an apply action it is caught here
     * This function should be overridden
     *
     * @function
     * @instance
     * @override
     *
     * @param  {Event} ev The event that goes with the action
     *
     * @return {None}
     */
    handleApplyAction: function(ev) {
    },

    /**
     * If there is a cancel action is is caught here
     *
     * @function
     * @instance
     * @override
     *
     * @param  {Event} ev The vent that goes with the action
     *
     * @return {None}
     */
    handleCancelAction: function(ev) {
      this.getDelegate().loadPreviousSection();
    },

    /**
     * handle button keydown events
     *
     * @function
     * @instance
     *
     * @param  {Event} ev The vent that goes with the action
     *
     * @return {None}
     */
    handleModalBtnKeydown: function(ev) {
      var $el          = $(ev.currentTarget);
      var isDismissBtn = $el.data('dismiss') === 'modal';
      var disabled     = $el.hasClass('disabled');

      // we don't do anything if the button is disabled
      if (disabled) { return }

      // Enter key - make it synonymous with a click
      if (ev.which === 13) {
        if (isDismissBtn) {
          // is this the button that hides the modal?
          this.hide();
        } else {
          // if not, try to handle the button's defined action
          this.handleModalBtnClick(ev);
        }
      }
    },

    /**
     * If any button is clicked that has a data-action attached to it, it is caught here
     *
     * @function
     * @instance
     *
     * @param  {Event} ev THe event that goes with the action
     *
     * @return {String} The name of the button action
     */
    handleModalBtnClick: function(ev) {
      var $el         = $(ev.currentTarget),
          action      = $el.data('action'),
          disabled    = $el.hasClass('disabled'),
          sectionView = this.getDelegate().getActiveSection().getView(),
          fn          = 'handle' + action.charAt(0).toUpperCase() + action.substring(1) + 'Action';

      if (!disabled) {
        // Section View Handler
        if ( _.isFunction(sectionView[fn]) ) {
          sectionView[fn].call(sectionView, ev);

        // Modal View Handler
        } else if (_.isFunction(this[fn])) {
          this[fn].call(this, ev);
        }
      }
    },

    /**
     * Load the section
     *
     * @function
     * @instance
     *
     * @param  {Evisions.Modal.ModalSectionController} section
     * @param  {Evisions.Modal.ModalSectionController} activeSection
     * @param  {Boolean} leftAnimation                 Animate left?
     *
     * @return {Deferred}                              Resolved after section animates
     */
    loadSection: function(section, activeSection, leftAnimation) {
      var delegate = this.getDelegate();

      if (!delegate.isShown) {
        section.getView().show();

        return $.when(section.getView().$el);
      } else {
        var sectionView       = section.getView(),
            activeSectionView = activeSection ? activeSection.getView() : null;

        return this.slideModalSection(sectionView, activeSectionView, leftAnimation);
      }
    },

    setTitle: function(txt) {
      return this.$('.modal-title').text(txt);
    },

    /**
     * Setup the section view
     *
     * @function
     * @instance
     *
     * @param  {Evisions.Modal.ModalSectionController} sectionController
     *
     * @return {None}
     */
    setupSectionView: function(section) {
      var sectionEl = this.getModalSectionElement(section);

      section.setup(sectionEl);
    },

    /**
     * Hides the modal
     *
     * @function
     * @instance
     *
     * @return {Deferred} A deferred object that will allow you to know hwne the animation is done
     */
    hide: function() {
      var that = this;

      return new Promise(function(resolve) {
        that.$el.one('hidden.bs.modal', resolve).modal('hide');
      });
    },

    /**
     * Initiates the show animation
     *
     * @function
     * @instance
     *
     * @return {Deferred} A deferred object that will allow you to know when the animation is done
     */
    show: function() {
      var options = this.getDelegate().getModalOptions(),
          that    = this;

      return new Promise(function(resolve) {
        that.$el.one('shown.bs.modal', resolve).modal(options);
      });
    },

    showLoading: function() {
      var el   = $(document.body),
          that = this;

      // Hide any existing spinners
      // helper.hideLoading();

      // Show spinner
      // helper.showLoading(el, false, true);

      return function() {
        that.hideLoading();
      }
    },

    hideLoading: function() {
    },

    slideModalSection: function(sectionView, activeSectionView, leftAnimation) {
      var d             = $.Deferred(),
          active      = null,
          section     = sectionView.$el;

      if (!activeSectionView) {
        sectionView.show();
        return d.resolve();
      } else {
        active = activeSectionView.$el;
      }

      // TODO - Rewrite sliding motion

      var speed = 'fast',
          easing = 'easeOutCubic';

      var container              = active.parent(),
          styles                 = ['display', 'left', 'top', 'width', 'height', 'position'],
          activeCurrentStyles    = $.styles(active.get(0), styles, true),
          sectionCurrentStyles   = $.styles(section.get(0), styles, true),
          containerCurrentStyles = $.styles(container.get(0), styles, true);

      var allDone = function() {
        active.css(activeCurrentStyles);
        active.hide();
        section.css(sectionCurrentStyles);
        container.css(containerCurrentStyles);
        section.removeClass('hide').show();
        d.resolve();
      };

      allDone = _.after(3, allDone);

      var activeOffset        = active.offset(),
          activeHeight          = active.height(),
          activeWidth           = active.outerWidth(true);

      section.show();

      var newSectionWidth       = section.outerWidth(true),
          newSectionHeight      = section.height();

      active.hide();

      var containerHeightToBe   = container.height();

      active.show();
      section.hide();

      var containerHeight       = container.height(),
          containerPosition     = container.offset(),
          containerWidth        = container,
          containerPositionType = container.css('position'),
          paddingLeft           = parseInt(container.css('padding-left')) || 0,
          paddingTop            = parseInt(container.css('padding-top')) || 0,
          paddingBottom         = parseInt(container.css('padding-bottom')) || 0,
          paddingRight          = parseInt(container.css('padding-right')) || 0,
          containerTotalWidth   = container.outerWidth(true),
          activePosition     = {
            top: (activeOffset.top - containerPosition.top),
            left: (activeOffset.left - containerPosition.left)
          },
          sectionPosition  = {
            top  : activePosition.top,
            left : activePosition.left + (left ? containerTotalWidth : -containerTotalWidth)
          };
      //make sure that the container is not position static
      if (containerPositionType == 'static') {
        container.css('position', 'relative');
      }

      container
          .height(containerHeight)
          .width(containerWidth)
          // .css({ overflow: 'hidden' })
          .animate({ height : containerHeightToBe }, speed, easing, allDone);


      active
          .removeClass('active')
          .height(activeHeight)
          .width(activeWidth)
          .css(activePosition)
          .css({ position: 'absolute' })
          .animate({ left : (left ? (activePosition.left - containerTotalWidth) : (activePosition.left + containerTotalWidth)) }, speed, easing, allDone);

      section
          .addClass('active')
          .show()
          .height(newSectionHeight)
          .width(newSectionWidth)
          .css(sectionPosition)
          .css({ position: 'absolute' })
          .animate({ left: activePosition.left }, speed, easing, allDone);

      return d;
    },

    /**
     * Called when the show animation starts
     *
     * @function
     * @instance
     *
     * @return {None}
     */
    viewDidShow: function(ev) {
      if (ev.target === this.el) {
        this.getDelegate().viewDidShow();
      }
    },

    /**
     * Called when the show animation is finished
     *
     * @function
     * @instance
     *
     * @return {None}
     */
    viewDidFinishShowing: function(ev) {
      if (ev.target === this.el) {
        this.getDelegate().viewDidFinishShowing();
      }
    },

    /**
     * Called the the hide animation starts
     *
     * @function
     * @instance
     *
     * @return {None}
     */
    viewDidHide: function(ev) {
      if (ev.target === this.el) {
        this.getDelegate().viewDidHide();
      }
    },

    /**
     * Called when the hide animation is finished
     *
     * @function
     * @instance
     *
     * @return {None}
     */
    viewDidFinishHiding: function(ev) {
      if (ev.target === this.el) {
        this.getDelegate().viewDidFinishHiding();
      }
    }

  });


  var ModalController = Vertebrae.Controller.extend({

    properties: [
      'data',
      'backdrop',
      'dismiss',
      'keyboard',
      'mainSection',
      'remote',
      'sectionStack',
      'title',
      'help'
    ],

    initialize: function(options) {
      var properties = this.getDefaultProperties(options || {});

      this.applyProperties(properties);

      this._super.apply(this, arguments);

      // Refresh modal title on change
      this.sync('title');
    },

    /**
     * Refresh the modal title
     *
     * @function
     * @instance
     */
    refreshTitlePropertyOnView: function() {
      this.getView().setTitle(this.getTitle());
    },

    resolve: function(data) {
      // Indicates data has been attached
      this.hasBeenResolved = true;

      this.setData(data);
      
      return this.close();
    },

    /**
     * Hide the modal
     *
     * @function
     * @instance
     * 
     * @return {Deferred}
     */
    close: function() {
      return this.getView().hide();
    },

    /**
     * Destroy the currently active section, before calling destroy on the modal
     *
     * @function
     * @instance
     */
    destroy: function() {
      var section = this.getActiveSection();

      if (section) {
        section.destroy();
      }

      this._super.apply(this, arguments);
    },

    /**
     * Return the controller properties with their default values set
     *
     * @function
     * @instance
     * 
     * @return {Object} 
     */
    getDefaultProperties: function(options) {
      if (options.dismiss == false) {
        // Disable close modal on escape key
        if (options.keyboard == null) {
          options.keyboard = false;
        }
        // Backdrop which doesn't close modal
        if (options.backdrop == null) {
          options.backdrop = 'static';
        }
      } else {
        options.dismiss = true;
      }

      return _.extend({
              sectionStack: [],
              title: 'Evisions'
            }, options);
    },

    /**
     * Get the active section's buttons
     *
     * @function
     * @instance
     * 
     * @return {Array} The array of button definitions
     */
    getButtons: function() {
      var section = this.getActiveSection();

      if (section) {
        if (_.isFunction(section.getButtons)) {
          return section.getButtons() || [];
        } else {
          return section.getView().buttons || [];
        }
      }
    },

    /**
     * Get the active section's footer text
     *
     * @function
     * @instance
     * 
     * @return {Object} Object containing the footer text options
     */
    getFooterText: function() {
      var section = this.getActiveSection();

      if (section) {
        if (_.isFunction(section.getFooterText)) {
          return section.getFooterText() || null;
        } else {
          return section.getView().footerText || null;
        }
      }
    },

    /**
     * Return the modal bootstrap options
     *
     * @function
     * @instance
     * 
     * @return {Object} 
     */
    getModalOptions: function() {
      return {
        backdrop: this.getBackdrop(),
        keyboard: this.getKeyboard(),
        show: true,
        remote: this.getRemote()
      }
    },

    setupView: function() {
      this.setView(new ModalView());
    },

    /**
     * Show the Modal
     *
     * @function
     * @instance
     * 
     * @return {Deferred} Resolved when the modal has been displayed
     */
    show: function() {
      var section           = this.getMainSection(),
          sectionDeferred   = Promise.resolve();

      // Load main section
      if (section) {
        sectionDeferred = this.loadSection(section);
      }

      // Before displaying, render possible section
      return sectionDeferred
        .bind(this)
        .then(function() {

          // Display modal
          return this.getView().show();
        })
        .then(function() {
          var that = this;

          this.isShown = true;
          this.triggerSectionLoaded(section);

          // Promise for returning modal data
          return new Promise(function(resolve) {
              that.listenToOnce(that, 'hidden', function() { 
                if (that.hasBeenResolved) { resolve(that.getData()); }
                else { that.destroy() }
              });
            })
            .bind(this)
            .lastly(this.destroy);
        });

    },

    /**
     * Get the currently active section controller
     *
     * @function
     * @instance
     * 
     * @return {Modal.ModalSectionController}
     */
    getActiveSection: function() {
      var mainSection = this.getMainSection();
      return (_.last(this.getSectionStack()) || mainSection);      
    },

    /**
     * Get the previous section on the stack
     *
     * @function
     * @instance
     * 
     * @return {Modal.ModalSectionController}
     */
    getPreviousSection: function() {
      var stack = this.getSectionStack();
      return stack[stack.length-2];
    },

    /**
     * Load a section into the modal
     *
     * @function
     * @instance
     * 
     * @param  {Modal.ModalSectionController} section
     * 
     * @return {Deferred}   Resolved when the section has finished showing
     */
    loadSection: function(section) {
      var section            = this.setupSection(section),
          activeSection      = this.getActiveSection(),
          previousSection    = this.getPreviousSection(),
          loadingNewSection  = (section != previousSection);

      // Unless loading a new section, push new section
      if (loadingNewSection) {
        this.getSectionStack().push(section);
      }

      // Refresh Header
      if (section && section.getTitle()) {
        this.setTitle(section.getTitle());
      }

      // Refresh footer
      this.getView().refreshFooter();

      // Request the section data
      return section.refresh()
        .bind(this)
        .then(function() {
          // Render the section
          return section.sectionIsReady();
        })
        .then(function() {
          // Display the section
          return this.getView().loadSection(section, activeSection, loadingNewSection);
        })
        .tap(function() {
          this.triggerSectionLoaded(section);
        })
        .lastly(this.showSectionBusy());
    },

    triggerSectionLoaded: function(section) {
      if (!this.isShown || !section) {
        return;
      }

      section.sectionDidLoad();
      this.sectionDidLoad(section);
    },  

    /**
     * Transition to the previous section, otherwise close the modal
     *
     * @function
     * @instance
     * 
     * @return {Deferred} 
     */
    loadPreviousSection: function() {
      var stack           = this.getSectionStack(),
          activeSection   = stack[stack.length-1],
          previousSection = stack[stack.length-2];

      // Remove active section from the stack
      stack.pop();

      // Unload currently active section
      activeSection.unload();

      if (previousSection) {
        return this.loadSection(previousSection);
      } else {
        return Promise.bind(this).tap(this.close);
      }
    },

    sectionDidLoad: function() {
    },

    /**
     * Sets up the passed section
     *
     * @function
     * @instance
     * 
     * @param  {Evisions.Modal.ModalSectionController} section
     * 
     * @return {Evisions.Modal.ModalSectionController} section
     */
    setupSection: function(section) {
      if (section._setup) {
        return section;
      }
      
      section.setModal(this);
      this.getView().setupSectionView(section); 

      // Cache section setup
      section._setup = true;

      return section;
    },

    showSectionBusy: function() {
      return this.getView().showLoading();
    },

    /**
     * Called when a modal has started to show
     *
     * @function
     * @instance
     * 
     * @return {None}
     */
    viewDidShow: function() {
      this.trigger('show');
    },

    /**
     * Called when a modal has finished showing
     *
     * @function
     * @instance
     * 
     * @return {None}
     */
    viewDidFinishShowing: function() {
      this.trigger('shown');
    },

    /**
     * Called when a modal has started to hide
     *
     * @function
     * @instance
     * 
     * @return {None} 
     */
    viewDidHide: function() {
      this.trigger('hide');
    },

    /**
     * Called when a modal has finished hiding
     *
     * @function
     * @instance
     * 
     * @return {None} 
     */
    viewDidFinishHiding: function() {
      this.trigger('hidden');
    }

  },{

    modalContainer: '#modals-container',

    create: function(section, options) {
      var options   = _.extend({
                        mainSection: section
                      }, options),
          el        = this.createModalElement(),
          modal     = null;

      // Initial section must be specified
      if (!section) {
        throw new Error('Modal must be created with an initial section.');
      }
      
      // Instantiate Modal
      modal = new ModalController(options);

      // Setup Modal
      modal.setup(el);

      // Destroy the created element on hide
      modal.listenToOnce(modal, 'hidden', function() { el.remove(); });

      return modal;
    },

    createModalElement: function() {
      var container = $(this.modalContainer),
          el        = $('<div/>').addClass('modal fade').attr('tabindex', -1);

      if (!container.length) {
        container = $(document.body);
      }

      container.prepend(el);

      return el;
    }

  });

  
  var ModalSectionView = Vertebrae.View.extend({

    /**
     * Show the modal section
     *
     * @function
     * @instance
     * 
     * @return {None} 
     */
    show: function() {
      var that = this;

      return new Promise(function(resolve) {
        that.$el.show().promise().done(resolve);
      });
    },

    /**
     * Hide the modal section
     *
     * @function
     * @instance
     * 
     * @return {None} 
     */
    hide: function() {
      var that = this;

      return new Promise(function(resolve) {
        that.$el.hide().promise().done(resolve);
      });
    }

  });

  
  var ModalSectionController = Vertebrae.Controller.extend({

    className: '',

    modalClassName: '',

    properties: [
      'buttons',
      'footerText',
      'modal',
      'title'
    ],

    events: {
      'view:ready' : null
    },

    defaultTitle: null,

    initialize: function(properties) {
      properties = properties || {};

      _.defaults(properties, this.defaultProperties());

      this.applyProperties(properties);

      this._super.apply(this, arguments);
    },

    defaultProperties: function() {
      // Always assign a default title
      return {
        title: this.defaultTitle,
        defaultBtn: true
      };
    },

    getButtons: function() {
      if (!_.isEmpty(this.buttons) || !this.defaultBtn) {
        return this.get('buttons') || [];
      } else {
        return [{
          text: 'Close',
          dismiss: true
        }]
      }
    },

    /**
     * Called when a modal section needs to make an api call in order to get its data
     *
     * @function
     * @instance
     * @override
     * 
     * @return {None} 
     */
    refresh: function() {
      return Promise.resolve();
    },

    /**
     * Called when a section is ready for rendering/manipulation
     *
     * @function
     * @instance
     * @override
     * 
     * @return {None} 
     */
    sectionIsReady: function() {
      return this.render();
    },

    /**
     * Called when a section has finished animating into place.  Often used for focusing on elements.
     *
     * @function
     * @instance
     * @override
     * 
     * @return {None}
     */
    sectionDidLoad: function() {
      //lets us know the section finished animating
    },

    setupView: function() {
      this.setView(new ModalSectionView());
    },
    
    /**
     * Showing a loading wheel
     *
     * @function
     * @instance
     * 
     * @return {None} 
     */
    showLoading: function() {
      return this.getModal().showSectionBusy();
    }

  },{

    create: function(properties) {
      // Allows for instantiating using the title only
      if (_.isString(properties)) {
        properties = { title: properties }
      }

      return new this(properties);
    },

    setupModalOptions: function(options) {
      return options || {};
    },

    show: function(properties, modalOptions) {
      var modal    = null,
          section  = this.create(properties),
          options  = this.setupModalOptions(modalOptions);

      modal = ModalController.create(section, options);

      return modal.show();
    }

  });


  var ModalMessageView = ModalSectionView.extend({

    templates: {
      'modal.message.default' : 'renderDefaultMsgFragment'
    },

    /**
     * Render with specified template otherwise use default.
     *
     * @function
     * @instance
     */
    render: function() {
      var template      = this.getDelegate().getTemplate(),
          templateProps = this.getDelegate().getTemplateProperties();

      if (template) {
        this.$el.html(this.template(template, templateProps));
      } else {
        this.$el.html(this.renderDefaultMsgFragment(templateProps));
      }
    },

    /**
     * Append additional messages
     *
     * @function
     * @instance
     */
    addMessage: function(msg) {
      this.$el.append(msg);
    }
    
  });


    var ModalMessageController = ModalSectionController.extend({

    properties: [
      'message',
      'template'
    ],

    addMessage: function(msg) {
      this.getView().addMessage(msg);
    },

    /**
     * Get the data that drives the template
     *
     * @function
     * @instance
     * 
     * @return {Object} 
     */
    getTemplateProperties: function() {
      return {
        message: this.getMessage()
      };
    },

    setupView: function() {
      this.setView(new ModalMessageView());
    }

  },{
    
    /**
     * Create a new modal message section controller with the given message/template and buttons
     *
     * @function
     * 
     * @param  {Object} options     Include message content, and possible buttons { content: '', buttons: [] }
     * 
     * @return {Evisions.ArgosWeb.Modals.ModalMessageController}         
     */
    create: function(properties) {
      var content = properties.content;

      if (Vertebrae.View.hasTemplate(content)) {
        properties.template = content;
      } else {
        properties.message = content;
      }

      return new this(properties);
    }

  });


  var ModalButtonMsgView = ModalSectionView.extend({

    templates: {
      'modal.message.default' : 'renderDefaultMsgFragment'
    },

    /**
     * Render with specified message.
     *
     * @function
     * @instance
     */
    render: function() {
      var templateProp = this.getDelegate().getTemplateProperties();
      
      this.$el.html(this.renderDefaultMsgFragment(templateProp));
    }
    
  });


  var ModalButtonMsgController = ModalSectionController.extend({

    properties: [
      'message'
    ],

    defaultProperties: function() {
      return _.extend(this._super(), {
        defaultBtn: false
      });
    }, 

    getTemplateProperties: function() {
      return {
        message: this.getMessage()
      }
    },

    setButtons: function(btns) {
      this.set('buttons', _.map(btns, function(btn) {
        if (_.isString(btn)) {
          return { 
            text: btn
          };
        } else {
          return btn;
        }
      }));
      return this;
    },

    setupHandlers: function() {
      var btns    = this.getButtons(),
          newBtns = [],
          btn     = null,
          fnName  = '';

      for (var i = 0, len = btns.length; i < len; i++) {
        btn = _.clone(btns[i]);
        newBtns.push(btn);

        // Generate action name
        if (btn.action || btn.dismiss) {
          continue;
        } else {
          btn.action = 'AutoGenerated' + i;
        }

        // Generate action handler on the view
        fnName = 'handle' + btn.action + 'Action';

        (function(button, section) {
          section.getView()[fnName] = function() {
            section.buttonClicked(button);
          }
        })(btn, this);
      }

      this.set('buttons', newBtns);
    },

    setupView: function() {
      this.setView(new ModalButtonMsgView());

      this.setupHandlers();
    },

    buttonClicked: function(button) {
      this.getModal().resolve(button.text);
    }

  },{

    /**
     * Instantiate a new Button Message Section Object
     *
     * @function
     * @constructor
     *
     * @param {Object} properties     Properties for modal section definition { buttons: '', title: '', message: ''}
     */
    create: function(properties) {
      var btns = properties.buttons;

      // Allows for single button string definition
      if (btns && !_.isArray(btns)) {
        properties.buttons = [btns];
      }

      return new this(properties);
    },

    setupModalOptions: function(options) {
      // Only allow modal dismissal through buttons
      return _.extend({
        dismiss: false
      }, options);
    }

  });


this["E3Templates"] = this["E3Templates"] || {};
this["E3Templates"]["e3-modal"] = this["E3Templates"]["e3-modal"] || {};

this["E3Templates"]["e3-modal"]["modal.button"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return " aria-label=\""
    + escapeExpression(((helper = (helper = helpers.ariaLabel || (depth0 != null ? depth0.ariaLabel : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"ariaLabel","hash":{},"data":data}) : helper)))
    + "\"";
},"3":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return " aria-labelledby=\""
    + escapeExpression(((helper = (helper = helpers.ariaLabelledby || (depth0 != null ? depth0.ariaLabelledby : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"ariaLabelledby","hash":{},"data":data}) : helper)))
    + "\"";
},"5":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return " aria-describedby=\""
    + escapeExpression(((helper = (helper = helpers.ariaDescribedby || (depth0 != null ? depth0.ariaDescribedby : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"ariaDescribedby","hash":{},"data":data}) : helper)))
    + "\"";
},"7":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return escapeExpression(((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"color","hash":{},"data":data}) : helper)));
  },"9":function(depth0,helpers,partials,data) {
  return "default";
  },"11":function(depth0,helpers,partials,data) {
  return "pull-left";
  },"13":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return " data-action=\""
    + escapeExpression(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"action","hash":{},"data":data}) : helper)))
    + "\"";
},"15":function(depth0,helpers,partials,data) {
  return " data-dismiss=\"modal\"";
  },"17":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "    <i class=\"icon-"
    + escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"icon","hash":{},"data":data}) : helper)))
    + "\"></i>\r\n";
},"19":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "    "
    + escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"text","hash":{},"data":data}) : helper)))
    + "\r\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, buffer = "<div\r\n  role=\"button\"\r\n  tabindex=\"0\"\r\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.ariaLabel : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\r\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.ariaLabelledby : depth0), {"name":"if","hash":{},"fn":this.program(3, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\r\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.ariaDescribedby : depth0), {"name":"if","hash":{},"fn":this.program(5, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\r\n  class=\"btn btn-";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.color : depth0), {"name":"if","hash":{},"fn":this.program(7, data),"inverse":this.program(9, data),"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.left : depth0), {"name":"if","hash":{},"fn":this.program(11, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\"\r\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.action : depth0), {"name":"if","hash":{},"fn":this.program(13, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\r\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.dismiss : depth0), {"name":"if","hash":{},"fn":this.program(15, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += ">\r\n";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.icon : depth0), {"name":"if","hash":{},"fn":this.program(17, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.text : depth0), {"name":"if","hash":{},"fn":this.program(19, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</div>\r\n";
},"useData":true});

this["E3Templates"]["e3-modal"]["modal.footer.base"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "<span class=\"pull-left\">"
    + escapeExpression(((helper = (helper = helpers.footerText || (depth0 != null ? depth0.footerText : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"footerText","hash":{},"data":data}) : helper)))
    + "</span>\r\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, buffer = "";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.footerText : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\r\n";
  stack1 = ((helper = (helper = helpers.buttons || (depth0 != null ? depth0.buttons : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"buttons","hash":{},"data":data}) : helper));
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"useData":true});

this["E3Templates"]["e3-modal"]["modal.header.base"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "<a class=\"modal-help\" href=\""
    + escapeExpression(((helper = (helper = helpers.help || (depth0 != null ? depth0.help : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"help","hash":{},"data":data}) : helper)))
    + "\" target=\"_blank\"><i class=\"icon-question-circle\"></i></a>\r\n";
},"3":function(depth0,helpers,partials,data) {
  return "<button type=\"button\" class=\"close\" data-dismiss=\"modal\"><i class=\"icon-times\"></i></button>\r\n";
  },"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, buffer = "<span class=\"modal-title\">"
    + escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"title","hash":{},"data":data}) : helper)))
    + "</span>\r\n";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.help : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\r\n";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.dismiss : depth0), {"name":"if","hash":{},"fn":this.program(3, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"useData":true});

this["E3Templates"]["e3-modal"]["modal.init"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  return "<div class=\"modal-dialog\">\r\n  <div class=\"modal-content\">\r\n    <div class=\"modal-header\"></div>\r\n    <div class=\"modal-body\"></div>\r\n    <div class=\"modal-footer\"></div>\r\n  </div>\r\n</div>";
  },"useData":true});

this["E3Templates"]["e3-modal"]["modal.message.default"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, buffer = "<div class=\"text-center\">";
  stack1 = ((helper = (helper = helpers.message || (depth0 != null ? depth0.message : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"message","hash":{},"data":data}) : helper));
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</div>";
},"useData":true});

  
  var Modal = {
    Controller            : ModalController,
    View                  : ModalView,
    SectionController     : ModalSectionController,
    SectionView           : ModalSectionView,
    MsgModal              : ModalMessageController,
    MsgView               : ModalMessageView,
    BtnMsgModal           : ModalButtonMsgController,
    BtnMsgView            : ModalButtonMsgView,
    templates             : this.E3Templates['e3-modal'],
    version               : '0.0.25'
  };

  return Modal;

}));

